export default "__VITE_PUBLIC_ASSET__afa060f3__"